import React, { useState } from "react";
import { Button } from "../../components/Button/Button";
import { GetChangePassword } from "../../api/api";
import Cookies from "js-cookie";

export const ChangePassword = () => {
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const [currentPassword, setCurrentPassword] = useState(null);
  const [newPassword, setNewPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [response, setResponse] = useState<any>(null);
  const [errorResponse, setErrorResponse] = useState<any>(null);
  const [responseState, setResponseState] = useState(false);

  function handleCurrentPassword(e: any) {
    setCurrentPassword(e.target.value);
  }
  function handleNewPassword(e: any) {
    setNewPassword(e.target.value);
  }
  function handleConfirmPassword(e: any) {
    setConfirmPassword(e.target.value);
  }

  function handlebtnClick() {
    if (newPassword === confirmPassword) {
      setIsBtnLoading(true);
      GetChangePassword(
        currentPassword,
        newPassword,
        confirmPassword,
        Cookies.get("newJwt")
      )
        .then((response) => response.json())
        .then((response) => {
          setResponse(response?.errors?.[0]?.message ?? "");
          setResponseState(true);
          setIsBtnLoading(false);
        })
        .catch((error) => {
          setErrorResponse(error);
          console.log("error: " + error);
          setIsBtnLoading(false);
          setResponse('Password Changed Successfully')
        });
    }
  }



  return (
    <div>
      <div className="header">
        <h1 className="header-title">Change Password</h1>
      </div>
      <div className="row w-100 card p-4">
        <div
          className="tradeForm position-relative m-auto"
          style={{ width: 400 }}
        >
          <div className="my-3">
            <label htmlFor="email" className="text-body">
              Current Password
            </label>
            <input
              type="password"
              className="form-control"
              onChange={(e) => handleCurrentPassword(e)}
            />
          </div>
          <div className="my-3">
            <label htmlFor="email" className="text-body">
              New Password
            </label>
            <input
              type="password"
              className="form-control"
              onChange={(e) => handleNewPassword(e)}
            />
          </div>
          <div className="my-3">
            <label htmlFor="email" className="text-body">
              Confirm Password
            </label>
            <input
              type="password"
              className="form-control"
              onChange={(e) => handleConfirmPassword(e)}
            />
          </div>
          {responseState !== true ? (
            <div className="text-success">{response}</div>
          ) : <div className="text-danger">{response}</div>}
         
          <div className="text-center mt-3">
            <Button
              type="submit"
              className="btn-primary"
              size="btn-xs"
              children="Continue"
              showLoading={isBtnLoading}
              onClick={handlebtnClick}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
